var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mw-dialog',{ref:"dialog",attrs:{"title":_vm.title,"appendToBody":false,"size":"full","before-close":_vm.closeWindow}},[_c('mw-ntko-editor',{ref:"editor",attrs:{"defButtons":_vm.buttons,"propObject":_vm.propObject}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dae08ee4","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/index/components/public-dialog/ntko/ntko-editor.vue
// module id = 1169
// module chunks = 0 1